import { ECompanyTypeIdConst } from '@company/companyType/companyType.constants';
import { AppConfigContext } from '@config/AppConfig';
import { IMasterScheduleDetail } from '@masterSchedule/detail/masterScheduleDetail.models';
import { useNominatedInMasterSchedule } from '@masterSchedule/masterSchedule.hooks';
import { ERolePermission, ETransmittalPermission } from '@userProfile/permission/permission.constants';
import { hasAllPermissionsInArray, hasAtLeastOnePermissionsInArray } from '@userProfile/permission/permission.services';
import { useContext } from 'react';

export const useAllowNewDT = () => {
  const appConfigs = useContext(AppConfigContext);
  return hasAtLeastOnePermissionsInArray(
    appConfigs.configs.myPermissions,
    [ERolePermission.ALL_DESIGNERS, ETransmittalPermission.DESIGNER_UPDATE],
    ECompanyTypeIdConst.DESIGNER,
  );
};

export const useAllowNewDTWithT1 = (
  masterScheduleIsCancelled: boolean,
  masterScheduleType: string,
  userCompanyId: number,
  targetT1CompanyId: number,
) => {
  const isPermitted = useAllowNewDT();
  // TODO check master schedule type
  if (masterScheduleIsCancelled || masterScheduleType === 'D') return false;

  if (targetT1CompanyId !== userCompanyId) return false;
  return isPermitted;
};

export const useAllowEndorseDT = (masterSchedule?: IMasterScheduleDetail) => {
  const appConfigs = useContext(AppConfigContext);
  const { isNominatedDesigner } = useNominatedInMasterSchedule(masterSchedule);

  if (!isNominatedDesigner) return false;

  return hasAllPermissionsInArray(
    appConfigs.configs.myPermissions,
    [ETransmittalPermission.ENDORSE, ERolePermission.DESIGNER_AUTHORISED_REPRESENTATIVE],
    masterSchedule?.responsibleDesigner?.companyTypeId,
    masterSchedule?.responsibleDesigner?.organizationTypeId,
  );
};
